import { TableBody, TableHead } from "@mui/material";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "../../login/Axios-interceptor";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

// import Button from "@mui/material/Button";
// import axios from "axios";
import "./AdminComponents.scss";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";

import { Grid, Button, FormControl, MenuItem, Select } from "@mui/material";
import SaveAlt from "@mui/icons-material/SaveAlt";
import EditIcon from "@mui/icons-material/Edit";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dropzone from "react-dropzone";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BrandingContext } from "../../../BrandingProvider";
import {
  buildTemplateConfigPayload,
  getBrandingTemplateConfig,
  getTemplateConfigForEditForm,
  parseTemplateConfigInput,
} from "../../../utils/templateConfig";
import ApiDatePickerField from "../../../components/date/ApiDatePickerField";
import DisplayDate from "../../../components/date/DisplayDate";
import { formatDateForDisplay } from "../../../utils/displayDateFormat";

/** Preserve template_config shape for edit modal/save without injecting new defaults. */
const TEMPLATE_SECTION_LABELS = {
  chiefComplaints: "Chief Complaints",
  historyOfPresentIllness: "History of Present Illness",
  historyOfPastIllness: "History of Past Illness",
  vitals: "Vitals",
  diagnosis: "Diagnosis",
  testsInvestigations: "Tests / Investigations",
  medications: "Medications (Rx)",
  medicalAdvice: "Medical Advice",
  followUp: "Follow Up",
  referral: "Referral",
  drugHistory: "Drug History",
  doctorSignature: "Doctor Signature",
  adultVaccination: "Adult Vaccination",
  dentalExamination: "Dental Examination",
};

function DoctorList({ refreshList }) {
  const brandingData = useContext(BrandingContext);
  const brandingTemplateConfig = getBrandingTemplateConfig(brandingData);

  const [userData, setUserData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const [doctorlist, setDoctorsList] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
  const [userIdToReactivate, setUserIdToReactivate] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editSourceRow, setEditSourceRow] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [assistantOptions, setAssistantOptions] = useState([]);
  const [signaturePreview, setSignaturePreview] = useState("");
  const [templateFileName, setTemplateFileName] = useState("");
  const [editDoctorData, setEditDoctorData] = useState({
    dr_id: null,
    doctor_id: "",
    name: "",
    hospital: "",
    salutation: "",
    first_name: "",
    last_name: "",
    username: "",
    password: "",
    email: "",
    phone_no: "",
    specialization: "",
    qualifications: "",
    registration_no: "",
    dob: "",
    date_joined: "",
    gender: "",
    availability_start: "",
    availability_end: "",
    photo: null,
    address: "",
    state: "",
    city: "",
    fees: "",
    department: "",
    active: true,
    rating: "0",
    assistant: [],
    doctor_signature: [],
    template_config: {},
    template: "",
    followup_duration: "31",
    report_visit_duration: "7",
    requires_prescription_signature: true,
  });
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "facility admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "facility admin") &&
      Token()
    ) {
      fetchDoctors();
    }
  }, [authToken, refreshList]);

  useEffect(() => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers: headers,
      })
      .then((res) => {
        setDepartments(res.data?.department_list || []);
      })
      .catch(() => {
        setDepartments([]);
      });
  }, [authToken]);

  useEffect(() => {
    const roleType = sessionStorage.getItem("roleType");
    const facilityIdFromSession =
      sessionStorage.getItem("facility_id") ||
      sessionStorage.getItem("facility_name") ||
      "";
    const postData = {
      role_type: roleType,
      facility_id: facilityIdFromSession,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_user_list_for_doctors_assistant/`,
        JSON.stringify(postData),
        {
          headers: headers,
        }
      )
      .then((res) => {
        const filteredUserList = (res.data?.user_list || []).filter(
          (user) => !user.facility_admin
        );
        setAssistantOptions(filteredUserList);
      })
      .catch(() => {
        setAssistantOptions([]);
      });
  }, [authToken]);

  function fetchDoctors() {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_doctors/`, {
          headers: headers,
        })
        .then((response) => {
          const doctorsWithId = response.data?.data.map((doctor, index) => ({
            ...doctor,
            id: index + 1, // You can use a better strategy to generate unique IDs
          }));
          setDoctorsList(doctorsWithId);
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }
  const getRowClassName = (params) => {
    return "custom-row";
  };

  const getNameParts = (row) => {
    const fullName = (row?.name || "").trim();
    if (!fullName) {
      return {
        first_name: row?.first_name || "",
        last_name: row?.last_name || "",
      };
    }
    const splitName = fullName.split(/\s+/);
    return {
      first_name: row?.first_name || splitName[0] || "",
      last_name:
        row?.last_name || splitName.slice(1).join(" ") || splitName[0] || "",
    };
  };

  const buildEditUserPayload = (updatedRow, previousRow) => {
    const mergedRow = { ...previousRow, ...updatedRow };
    const nameParts = getNameParts(mergedRow);
    const normalizedAssistant = Array.isArray(mergedRow.assistant)
      ? mergedRow.assistant
      : Array.isArray(mergedRow.assistants)
        ? mergedRow.assistants
          .map((assistantObj) => assistantObj?.id)
          .filter((id) => id !== undefined && id !== null)
        : [];
    const payload = {
      dr_id: mergedRow.dr_id ?? null,
      doctor_id: mergedRow.doctor_id || "",
      facility_id:
        sessionStorage.getItem("facility_id") ||
        sessionStorage.getItem("facility_name") ||
        "",
      first_name: nameParts.first_name,
      last_name: nameParts.last_name,
      salutation: mergedRow.salutation || "",
      email: mergedRow.email || "",
      username: mergedRow.username || "",
      password: mergedRow.password || "",
      dob: mergedRow.dob || null,
      date_joined: mergedRow.date_joined || null,
      gender: mergedRow.gender || "",
      address: mergedRow.address || "",
      phone_no: mergedRow.phone_no || "",
      state: mergedRow.state || "",
      city: mergedRow.city || "",
      specialization: mergedRow.specialization || "",
      fees:
        mergedRow.fees !== undefined && mergedRow.fees !== null
          ? String(mergedRow.fees)
          : "",
      department: mergedRow.department || "",
      qualifications: mergedRow.qualifications || "",
      registration_no: mergedRow.registration_no || "",
      active: Boolean(mergedRow.active),
      assistant: normalizedAssistant,
      doctor_signature: normalizeDoctorSignatureForPayload(
        mergedRow.doctor_signature
      ),
      user_type: "Doctor",
      role: "doctor",
      rating:
        mergedRow.rating !== undefined && mergedRow.rating !== null
          ? String(mergedRow.rating)
          : "4.0",
      template_config: buildTemplateConfigPayload(
        updatedRow.template_config ?? mergedRow.template_config,
        brandingTemplateConfig,
      ),
      template: stripDataUrlPrefix(String(mergedRow.template || "")) || null,
      followup_duration:
        mergedRow.followup_duration !== undefined &&
          mergedRow.followup_duration !== null
          ? String(mergedRow.followup_duration)
          : "31",
      report_visit_duration:
        mergedRow.report_visit_duration !== undefined &&
          mergedRow.report_visit_duration !== null
          ? String(mergedRow.report_visit_duration)
          : "7",
      requires_prescription_signature:
        mergedRow.requires_prescription_signature !== undefined
          ? Boolean(mergedRow.requires_prescription_signature)
          : true,
    };
    return payload;
  };

  const handleDoctorEdit = async (updatedRow, previousRow) => {
    const payload = buildEditUserPayload(updatedRow, previousRow);
    const response = await axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}edit_user/`,
      payload,
      {
        headers: {
          ...headers,
          "Content-Type": "application/json",
        },
      }
    );
    const apiStatus = String(response?.data?.status || "").toLowerCase();
    if (apiStatus && apiStatus !== "success") {
      throw new Error(
        response?.data?.error ||
        response?.data?.message ||
        "Unable to update doctor",
      );
    }
    return { ...previousRow, ...updatedRow };
  };

  const splitName = (name = "") => {
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    return {
      first_name: parts[0] || "",
      last_name: parts.slice(1).join(" "),
    };
  };

  const formatDateForInput = (value = "") => {
    if (!value) return "";
    return String(value).split("T")[0];
  };

  const normalizeBase64Image = (value = "") => {
    if (!value || typeof value !== "string") return "";
    if (value.startsWith("data:image")) return value;
    return `data:image/png;base64,${value}`;
  };

  const ensureDataUrlBase64 = (value = "", fallbackType = "image/png") => {
    if (!value || typeof value !== "string") return "";
    if (value.startsWith("data:image")) return value;
    return `data:${fallbackType};base64,${value}`;
  };

  const stripDataUrlPrefix = (value = "") => {
    if (!value || typeof value !== "string") return "";
    const marker = ";base64,";
    const markerIndex = value.indexOf(marker);
    if (markerIndex === -1) return value.trim();
    return value.slice(markerIndex + marker.length).trim();
  };

  const normalizeDoctorSignatureForPayload = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (!item) return null;
          if (typeof item === "string") {
            const dataUrl = ensureDataUrlBase64(item, "image/png");
            return dataUrl
              ? {
                name: "signature.png",
                type: "image/png",
                size: 0,
                base64: dataUrl,
              }
              : null;
          }
          const type = item.type || "image/png";
          const dataUrl = ensureDataUrlBase64(String(item.base64 || ""), type);
          return dataUrl
            ? {
              name: item.name || "signature.png",
              type,
              size:
                item.size !== undefined && item.size !== null
                  ? Number(item.size)
                  : 0,
              base64: dataUrl,
            }
            : null;
        })
        .filter(Boolean);
    }
    if (typeof value === "string") {
      const dataUrl = ensureDataUrlBase64(value.trim(), "image/png");
      return dataUrl
        ? [
          {
            name: "signature.png",
            type: "image/png",
            size: 0,
            base64: dataUrl,
          },
        ]
        : [];
    }
    if (typeof value === "object") {
      const type = value.type || "image/png";
      const dataUrl = ensureDataUrlBase64(String(value.base64 || ""), type);
      return dataUrl
        ? [
          {
            name: value.name || "signature.png",
            type,
            size:
              value.size !== undefined && value.size !== null
                ? Number(value.size)
                : 0,
            base64: dataUrl,
          },
        ]
        : [];
    }
    return [];
  };

  const openEditModal = (row) => {
    const fallbackNameParts = splitName(row?.name || "");
    const assistantIdsFromPayload = Array.isArray(row?.assistant)
      ? row.assistant
      : Array.isArray(row?.assistants)
        ? row.assistants
          .map((assistantObj) => assistantObj?.id)
          .filter((id) => id !== undefined && id !== null)
        : [];
    const normalizedSignature = normalizeDoctorSignatureForPayload(
      row?.doctor_signature
    );
    setEditSourceRow(row);
    setEditDoctorData({
      dr_id: row?.dr_id || null,
      doctor_id: row?.doctor_id || "",
      name: row?.name || "",
      hospital: row?.hospital || "",
      salutation: row?.salutation || "",
      first_name: row?.first_name || fallbackNameParts.first_name,
      last_name: row?.last_name || fallbackNameParts.last_name,
      username: row?.username || "",
      password: row?.password || "",
      email: row?.email || "",
      phone_no: row?.phone_no || "",
      specialization: row?.specialization || "",
      qualifications: row?.qualifications || "",
      registration_no: row?.registration_no || "",
      dob: formatDateForInput(row?.dob),
      date_joined: formatDateForInput(row?.date_joined),
      gender: row?.gender || "",
      availability_start: row?.availability_start || "",
      availability_end: row?.availability_end || "",
      photo: row?.photo || null,
      address: row?.address || "",
      state: row?.state || "",
      city: row?.city || "",
      fees:
        row?.fees !== undefined && row?.fees !== null ? String(row.fees) : "",
      department: row?.department || "",
      active: Boolean(row?.active),
      rating:
        row?.rating !== undefined && row?.rating !== null
          ? String(row.rating)
          : "0",
      assistant: assistantIdsFromPayload.map((id) => String(id)),
      doctor_signature: normalizedSignature,
      template_config: getTemplateConfigForEditForm(
        row?.template_config,
        brandingTemplateConfig,
      ),
      template:
        stripDataUrlPrefix(
          typeof row?.template === "string"
            ? row.template
            : row?.template?.base64 || ""
        ),
      followup_duration:
        row?.followup_duration !== undefined && row?.followup_duration !== null
          ? String(row.followup_duration)
          : "31",
      report_visit_duration:
        row?.report_visit_duration !== undefined &&
          row?.report_visit_duration !== null
          ? String(row.report_visit_duration)
          : "7",
      requires_prescription_signature:
        row?.requires_prescription_signature !== undefined
          ? Boolean(row.requires_prescription_signature)
          : true,
    });
    const existingSignature = Array.isArray(row?.doctor_signature)
      ? normalizeBase64Image(row.doctor_signature[0]?.base64 || "")
      : typeof row?.doctor_signature === "string"
      ? normalizeBase64Image(row.doctor_signature)
      : "";
    setSignaturePreview(existingSignature);
    setTemplateFileName("");
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditSourceRow(null);
    setSignaturePreview("");
    setTemplateFileName("");
  };

  const handleEditFieldChange = (field, value) => {
    setEditDoctorData((prev) => ({ ...prev, [field]: value }));
  };

  const draggedSectionIndexRef = useRef(null);

  const handleTemplateConfigChange = (field, value) => {
    setEditDoctorData((prev) => ({
      ...prev,
      template_config: {
        ...prev.template_config,
        [field]: value,
      },
    }));
  };

  const handleSectionVisibilityChange = (sectionId, isVisible) => {
    setEditDoctorData((prev) => ({
      ...prev,
      template_config: {
        ...prev.template_config,
        sectionsVisibility: {
          ...(prev.template_config.sectionsVisibility || {}),
          [sectionId]: isVisible,
        },
      },
    }));
  };

  const handleSectionDragStart = (index) => {
    draggedSectionIndexRef.current = index;
  };

  const handleSectionDragOver = (event) => {
    event.preventDefault();
  };

  const handleSectionDrop = (dropIndex) => {
    const dragIndex = draggedSectionIndexRef.current;
    draggedSectionIndexRef.current = null;
    if (dragIndex === null || dragIndex === dropIndex) return;

    setEditDoctorData((prev) => {
      const order = [...(prev.template_config.sectionOrder || [])];
      const [moved] = order.splice(dragIndex, 1);
      order.splice(dropIndex, 0, moved);
      return {
        ...prev,
        template_config: {
          ...prev.template_config,
          sectionOrder: order,
        },
      };
    });
  };

  const handleSignatureDrop = (acceptedFiles) => {
    const file = acceptedFiles?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = String(reader.result || "");
      setSignaturePreview(base64Data);
      setEditDoctorData((prev) => ({
        ...prev,
        doctor_signature: [
          {
            name: file.name,
            type: file.type,
            size: file.size,
            base64: base64Data,
          },
        ],
      }));
    };
    reader.readAsDataURL(file);
  };

  const clearSignature = () => {
    setSignaturePreview("");
    setEditDoctorData((prev) => ({
      ...prev,
      doctor_signature: [],
    }));
  };

  const handleTemplateFileChange = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setTemplateFileName(file.name);
      setEditDoctorData((prev) => ({
        ...prev,
        template: stripDataUrlPrefix(String(reader.result || "")),
      }));
    };
    reader.readAsDataURL(file);
  };

  const validateEditDoctorForm = () => {
    if (!String(editDoctorData.first_name || "").trim()) {
      toast.error("First Name is required.");
      return false;
    }
    if (!String(editDoctorData.last_name || "").trim()) {
      toast.error("Last Name is required.");
      return false;
    }
    if (!String(editDoctorData.phone_no || "").trim()) {
      toast.error("Phone Number is required.");
      return false;
    }
    const phoneDigits = String(editDoctorData.phone_no || "").replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      toast.error("Phone Number must be 10 digits.");
      return false;
    }
    if (!String(editDoctorData.email || "").trim()) {
      toast.error("Email is required.");
      return false;
    }
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(String(editDoctorData.email || "").trim())) {
      toast.error("Invalid email address");
      return false;
    }
    if (!String(editDoctorData.specialization || "").trim()) {
      toast.error("Specialization is required.");
      return false;
    }
    if (!String(editDoctorData.department || "").trim()) {
      toast.error("department is required.");
      return false;
    }
    if (!String(editDoctorData.qualifications || "").trim()) {
      toast.error("Qualifications is required.");
      return false;
    }
    if (String(editDoctorData.qualifications || "").length > 170) {
      toast.error("Maximum 170 characters allowed.");
      return false;
    }
    if (!String(editDoctorData.registration_no || "").trim()) {
      toast.error("Registration Number is required.");
      return false;
    }
    const feesValue = Number(editDoctorData.fees);
    if (String(editDoctorData.fees || "").trim() === "" || Number.isNaN(feesValue)) {
      toast.error("Fees is required.");
      return false;
    }
    if (feesValue < 0) {
      toast.error("Fees must be at least 0.");
      return false;
    }
    if (feesValue > 5000) {
      toast.error("Fees must be no more than 5000.");
      return false;
    }
    if (
      !Array.isArray(editDoctorData.assistant) ||
      editDoctorData.assistant.length === 0
    ) {
      toast.error("At least one assistant is required.");
      return false;
    }

    const normalizedSignatures = normalizeDoctorSignatureForPayload(
      editDoctorData.doctor_signature
    );
    const signature = normalizedSignatures[0];
    if (signature && typeof signature.size === "number") {
      if (signature.size > 2 * 1024 * 1024) {
        toast.error("Doctor signature file size must not exceed 2MB.");
        return false;
      }
    }

    const followupDuration = Number(editDoctorData.followup_duration);
    if (
      String(editDoctorData.followup_duration || "").trim() === "" ||
      Number.isNaN(followupDuration) ||
      followupDuration < 0
    ) {
      toast.error("Followup Duration must be a valid non-negative number.");
      return false;
    }

    const reportVisitDuration = Number(editDoctorData.report_visit_duration);
    if (
      String(editDoctorData.report_visit_duration || "").trim() === "" ||
      Number.isNaN(reportVisitDuration) ||
      reportVisitDuration < 0
    ) {
      toast.error("Report Visit Duration must be a valid non-negative number.");
      return false;
    }

    const templateConfigNumbers = [
      editDoctorData.template_config.printOfsetTop,
      editDoctorData.template_config.printOfsetLeft,
      editDoctorData.template_config.extraRightMargin,
      editDoctorData.template_config.extraBottomMargin,
    ];
    if (templateConfigNumbers.some((n) => Number.isNaN(Number(n)))) {
      toast.error("Template config numeric fields must be valid numbers.");
      return false;
    }

    return true;
  };

  const handleEditSave = async () => {
    if (!editSourceRow) return;
    if (!validateEditDoctorForm()) return;
    try {
      const normalizedEditData = {
        ...editDoctorData,
        dr_id: editDoctorData.dr_id || null,
        doctor_id: editDoctorData.doctor_id || "",
        hospital: editDoctorData.hospital || "",
        name: editDoctorData.name || "",
        availability_start: editDoctorData.availability_start || null,
        availability_end: editDoctorData.availability_end || null,
        photo: editDoctorData.photo || null,
        date_joined: editDoctorData.date_joined || null,
        rating:
          editDoctorData.rating !== undefined && editDoctorData.rating !== null
            ? String(editDoctorData.rating)
            : "0",
        assistant: Array.isArray(editDoctorData.assistant)
          ? editDoctorData.assistant.map((id) => {
            const numericId = Number(id);
            return Number.isNaN(numericId) ? id : numericId;
          })
          : [],
        doctor_signature: normalizeDoctorSignatureForPayload(
          editDoctorData.doctor_signature
        ),
        template_config: buildTemplateConfigPayload(
          editDoctorData.template_config,
          brandingTemplateConfig,
        ),
        template: stripDataUrlPrefix(String(editDoctorData.template || "")) || null,
      };

      await handleDoctorEdit(normalizedEditData, editSourceRow);
      toast.success("Doctor details updated successfully");
      closeEditModal();
      fetchDoctors();
    } catch (error) {
      console.error("Error updating doctor:", error);
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Unable to update doctor",
      );
    }
  };

  const columns = [
    { field: "salutation", headerName: "Salutation", width: 100, editable: true },
    { field: "name", headerName: "Name", width: 150 },
    { field: "hospital", headerName: "Facility", width: 150 },
    { field: "phone_no", headerName: "Phone Number", width: 150, editable: true },
    { field: "email", headerName: "Email", width: 150, editable: true },
    {
      field: "specialization",
      headerName: "Specialization",
      width: 150,
      editable: true,
    },

    {
      field: "qualifications",
      headerName: "Qualifications",
      width: 200,
      editable: true,
    },
    {
      field: "registration_no",
      headerName: "Registration No.",
      width: 200,
      editable: true,
    },
    {
      field: "dob",
      headerName: "Date of Birth",
      width: 150,
      editable: true,
      valueFormatter: (params) => formatDateForDisplay(params?.value) || "",
      renderCell: (params) => <DisplayDate value={params.value} emptyLabel="" />,
    },
    {
      field: "active",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <div
          style={{ color: params.value ? "green" : "red", fontWeight: "bold" }}
        >
          {params.value ? "Active" : "Inactive"}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 210,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={() => openEditModal(params.row)}
              sx={{ color: "#1976d2", mr: 1 }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {params.row.active ? (
            <button
              onClick={() => handleDeleteUser(params.row.dr_id)}
              style={{ color: "red", fontWeight: "bold" }}
            >
              Delete
            </button>
          ) : (
            <button
              onClick={() => handleReactivateUser(params.row.dr_id)}
              style={{ color: "green", fontWeight: "bold" }}
            >
              Reactivate
            </button>
          )}
        </>
      ),
    },
    {
      field: "doctor_console_management",
      headerName: "Doctor Console Management",
      width: 220,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="Doctor Console Management">
          <IconButton
            size="small"
            disabled={!params.row.doctor_id}
            onClick={() =>
              history.push(
                `/doctor-console-manager?doctor_id=${encodeURIComponent(params.row.doctor_id)}`,
              )
            }
            sx={{ color: "#1976d2" }}
          >
            <SettingsOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const handleDeleteUser = (userId) => {
    setUserIdToDelete(userId);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (userIdToDelete) {
      console.log("deleting..", userIdToDelete);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}deactivate_facility_user/${userIdToDelete}/`,
          { type: "doctor_user" },
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("User deleted successfully:", res.data);
          toast.success("Doctor Deleted Successfully");
          fetchDoctors();
        })
        .catch((err) => {
          console.error("Error deleting user:", err);
          toast.error("Doctor Deletion Unsuccessfull");
        })
        .finally(() => {
          setUserIdToDelete(null);
          setIsDeleteModalOpen(false);
        });
    }
  };

  const handleReactivateUser = (userId) => {
    setUserIdToReactivate(userId);
    setIsReactivateModalOpen(true);
  };

  const handleConfirmReactivate = () => {
    if (userIdToReactivate) {
      console.log("reactivating..", userIdToReactivate);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}activate_facility_user/${userIdToReactivate}/`,
          { type: "doctor_user" },
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("User reactivated successfully:", res.data);
          if (res.data.status === "Success") {
            toast.success("Doctor Activated Successfully");
            fetchDoctors();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error reactivating user:", err);
          toast.error("Error reactivating user");
        })
        .finally(() => {
          setUserIdToReactivate(null);
          setIsReactivateModalOpen(false);
        });
    }
  };

  const handleCancelReactivate = () => {
    setUserIdToReactivate(null);
    setIsReactivateModalOpen(false);
  };

  const handleCancelDelete = () => {
    setUserIdToDelete(null);
    setIsDeleteModalOpen(false);
  };

  const generatePdf = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Salutation", "Name", "Facility", "Phone number", "Email", "Specialization", "Qualifications", "Registration No.", "Date of Birth", "Status",]],
      body: doctorlist.map((dl) => [
        dl.salutation,
        dl.name,
        dl.hospital,
        dl.phone_no,
        dl.email,
        dl.specialization,
        dl.qualifications,
        dl.registration_no,
        dl.dob,
        dl.active,
      ]),
    });
    doc.save("Doctors_List.pdf");
  };

  const generateCsvData = () => {
    return doctorlist.map((dl) => ({
      "Facility": dl.hospital,
      "Salutation": dl.salutation,
      "Name": dl.name,
      "Phone Number": dl.phone_no,
      "Email": dl.email,
      "Specialization": dl.specialization,
      "Qualifications": dl.qualifications,
      "Registration No.": dl.registration_no,
      "Date of Birth": dl.dob,
      "Status": dl.active,
    }));
  };

  // console.log(doctorlist, "fetchDoctors()");
  return (
    <>
      <Modal
        open={isEditModalOpen}
        onClose={closeEditModal}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="edit-doctor-modal"
        aria-describedby="edit-doctor-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: { xs: "98%", sm: "90%", md: "80%", lg: "70%" },
            maxWidth: "1000px",
            maxHeight: "85vh",
            overflowY: "auto",
          }}
        >
          <h3 id="edit-doctor-modal" style={{ marginTop: 0, fontSize: "28px" }}>
            Edit Doctor
          </h3>
          <p id="edit-doctor-description" style={{ marginBottom: "16px" }}>
            Update doctor details and save changes.
          </p>

          <form className="contact-panel__form" onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-salutation" className="required-label">
                  Salutation
                </label>
                <div className="form-group">
                  <select
                    id="edit-salutation"
                    className="form-control"
                    value={editDoctorData.salutation}
                    onChange={(e) =>
                      handleEditFieldChange("salutation", e.target.value)
                    }
                  >
                    <option value="">Select Salutation</option>
                    {[
                      "Mr.",
                      "Mrs.",
                      "Ms.",
                      "Miss",
                      "Dr.",
                      "Prof.",
                      "Prof. Dr.",
                      "Master",
                      "Rev",
                      "Mx",
                    ].map(
                      (title) => (
                        <option key={title} value={title}>
                          {title}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-username" className="required-label">
                  User Name
                </label>
                <div className="form-group">
                  <input
                    id="edit-username"
                    type="text"
                    className="form-control"
                    value={editDoctorData.username}
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-first-name" className="required-label">
                  First Name
                </label>
                <div className="form-group">
                  <input
                    id="edit-first-name"
                    type="text"
                    className="form-control"
                    value={editDoctorData.first_name}
                    onChange={(e) =>
                      handleEditFieldChange("first_name", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-last-name" className="required-label">
                  Last Name
                </label>
                <div className="form-group">
                  <input
                    id="edit-last-name"
                    type="text"
                    className="form-control"
                    value={editDoctorData.last_name}
                    onChange={(e) =>
                      handleEditFieldChange("last_name", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            {/* <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-password" className="required-label">
                  Password
                </label>
                <div className="form-group">
                  <input
                    id="edit-password"
                    type="password"
                    className="form-control"
                    value={editDoctorData.password}
                    disabled
                    readOnly
                    onChange={(e) =>
                      handleEditFieldChange("password", e.target.value)
                    }
                  />
                </div>
              </div>
            </div> */}

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-phone" className="required-label">
                  Phone No.
                </label>
                <div className="form-group">
                  <input
                    id="edit-phone"
                    type="text"
                    className="form-control"
                    maxLength={10}
                    value={editDoctorData.phone_no}
                    onChange={(e) =>
                      handleEditFieldChange("phone_no", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-email" className="required-label">
                  Email
                </label>
                <div className="form-group">
                  <input
                    id="edit-email"
                    type="text"
                    className="form-control"
                    value={editDoctorData.email}
                    onChange={(e) => handleEditFieldChange("email", e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-specialization" className="required-label">
                  Specialization
                </label>
                <div className="form-group">
                  <input
                    id="edit-specialization"
                    type="text"
                    className="form-control"
                    value={editDoctorData.specialization}
                    onChange={(e) =>
                      handleEditFieldChange("specialization", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-qualifications" className="required-label">
                  Qualification
                </label>
                <div className="form-group">
                  <input
                    id="edit-qualifications"
                    type="text"
                    className="form-control"
                    maxLength={170}
                    value={editDoctorData.qualifications}
                    onChange={(e) =>
                      handleEditFieldChange("qualifications", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-registration-no" className="required-label">
                  Medical Registration No
                </label>
                <div className="form-group">
                  <input
                    id="edit-registration-no"
                    type="text"
                    className="form-control"
                    value={editDoctorData.registration_no}
                    onChange={(e) =>
                      handleEditFieldChange("registration_no", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-fees" className="required-label">
                  Fees
                </label>
                <div className="form-group">
                  <input
                    id="edit-fees"
                    type="number"
                    className="form-control"
                    min="0"
                    max="5000"
                    value={editDoctorData.fees}
                    onChange={(e) => handleEditFieldChange("fees", e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-department" className="required-label">
                  Department
                </label>
                <div className="form-group">
                  <select
                    id="edit-department"
                    className="form-control"
                    value={editDoctorData.department}
                    onChange={(e) =>
                      handleEditFieldChange("department", e.target.value)
                    }
                  >
                    <option value="">Select Department</option>
                    {departments.map((department, index) => (
                      <option key={index} value={department.department}>
                        {department.department}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-dob">Date of Birth</label>
                <div className="form-group form-group-date">
                  <ApiDatePickerField
                    id="edit-dob"
                    value={editDoctorData.dob || ""}
                    onChange={(next) => handleEditFieldChange("dob", next)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-gender">Gender</label>
                <div className="form-group">
                  <select
                    id="edit-gender"
                    className="form-control"
                    value={editDoctorData.gender}
                    onChange={(e) => handleEditFieldChange("gender", e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-date-joined">Practice started since</label>
                <div className="form-group form-group-date">
                  <ApiDatePickerField
                    id="edit-date-joined"
                    value={editDoctorData.date_joined || ""}
                    onChange={(next) =>
                      handleEditFieldChange("date_joined", next)
                    }
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-state">State</label>
                <div className="form-group">
                  <input
                    id="edit-state"
                    type="text"
                    className="form-control"
                    value={editDoctorData.state}
                    onChange={(e) => handleEditFieldChange("state", e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-city">City</label>
                <div className="form-group">
                  <input
                    id="edit-city"
                    type="text"
                    className="form-control"
                    value={editDoctorData.city}
                    onChange={(e) => handleEditFieldChange("city", e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-followup-duration" className="required-label">
                  Followup Duration (in days)
                </label>
                <div className="form-group">
                  <input
                    id="edit-followup-duration"
                    type="text"
                    className="form-control"
                    value={editDoctorData.followup_duration}
                    onChange={(e) =>
                      handleEditFieldChange("followup_duration", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label
                  htmlFor="edit-report-visit-duration"
                  className="required-label"
                >
                  Report Visit Duration (in days)
                </label>
                <div className="form-group">
                  <input
                    id="edit-report-visit-duration"
                    type="text"
                    className="form-control"
                    value={editDoctorData.report_visit_duration}
                    onChange={(e) =>
                      handleEditFieldChange("report_visit_duration", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-assistant">Select Assistant(s)</label>
                <div className="form-group">
                  <FormControl fullWidth>
                    <Select
                      id="edit-assistant"
                      className="form-control"
                      multiple
                      value={editDoctorData.assistant}
                      onChange={(e) =>
                        handleEditFieldChange("assistant", e.target.value)
                      }
                    >
                      {assistantOptions.map((user) => (
                        <MenuItem key={user.id} value={String(user.id)}>
                          {user.username}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-doctor-signature">Doctor Signature</label>
                <div className="form-group">
                  {signaturePreview ? (
                    <div
                      style={{
                        position: "relative",
                        width: "40%",
                        height: "30%",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={signaturePreview}
                        alt="Uploaded Signature"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                      <button
                        type="button"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={clearSignature}
                      >
                        &times;
                      </button>
                    </div>
                  ) : (
                    <Dropzone
                      onDrop={handleSignatureDrop}
                      maxFiles={1}
                      accept={{
                        "image/*": [".jpeg", ".jpg", ".png"],
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div
                          {...getRootProps({
                            className: "dropzone",
                            style: {
                              border: "2px dashed #ccc",
                              padding: "3px",
                              cursor: "pointer",
                            },
                          })}
                        >
                          <input {...getInputProps()} />
                          <p style={{ margin: 0 }}>
                            Drag & drop a file here, or click to select a file
                          </p>
                        </div>
                      )}
                    </Dropzone>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h5 style={{ textAlign: "left", marginBottom: "16px" }}>
                  Template Config
                </h5>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-show-footer">Show Footer</label>
                <div className="form-group">
                  <select
                    id="template-show-footer"
                    className="form-control"
                    value={String(editDoctorData.template_config.showFooter)}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "showFooter",
                        e.target.value === "true"
                      )
                    }
                  >
                    <option value="false">false</option>
                    <option value="true">true</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-print-offset-top">printOfsetTop</label>
                <div className="form-group">
                  <input
                    id="template-print-offset-top"
                    type="number"
                    className="form-control"
                    value={editDoctorData.template_config.printOfsetTop}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "printOfsetTop",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-show-top-header">showTopHeader</label>
                <div className="form-group">
                  <select
                    id="template-show-top-header"
                    className="form-control"
                    value={String(editDoctorData.template_config.showTopHeader)}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "showTopHeader",
                        e.target.value === "true"
                      )
                    }
                  >
                    <option value="false">false</option>
                    <option value="true">true</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-print-offset-left">printOfsetLeft</label>
                <div className="form-group">
                  <input
                    id="template-print-offset-left"
                    type="number"
                    className="form-control"
                    value={editDoctorData.template_config.printOfsetLeft}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "printOfsetLeft",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-extra-right-margin">
                  extraRightMargin
                </label>
                <div className="form-group">
                  <input
                    id="template-extra-right-margin"
                    type="number"
                    className="form-control"
                    value={editDoctorData.template_config.extraRightMargin}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "extraRightMargin",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-extra-bottom-margin">
                  extraBottomMargin
                </label>
                <div className="form-group">
                  <input
                    id="template-extra-bottom-margin"
                    type="number"
                    className="form-control"
                    value={editDoctorData.template_config.extraBottomMargin}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "extraBottomMargin",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-use-bg">useBackgroundTemplate</label>
                <div className="form-group">
                  <select
                    id="template-use-bg"
                    className="form-control"
                    value={String(
                      editDoctorData.template_config.useBackgroundTemplate
                    )}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "useBackgroundTemplate",
                        e.target.value === "true"
                      )
                    }
                  >
                    <option value="false">false</option>
                    <option value="true">true</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="template-show-doctor-signature">
                  showDoctorSignature
                </label>
                <div className="form-group">
                  <select
                    id="template-show-doctor-signature"
                    className="form-control"
                    value={String(
                      editDoctorData.template_config.showDoctorSignature ??
                      true,
                    )}
                    onChange={(e) =>
                      handleTemplateConfigChange(
                        "showDoctorSignature",
                        e.target.value === "true"
                      )
                    }
                  >
                    <option value="false">false</option>
                    <option value="true">true</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <label>Prescription Section Order</label>
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: "#666",
                    marginBottom: "8px",
                  }}
                >
                  Drag rows to reorder sections in the prescription PDF.
                  Uncheck &quot;Visible&quot; to hide a section.
                </p>
                <div
                  style={{
                    border: "1px solid #c3e8e5",
                    borderRadius: "8px",
                    overflow: "hidden",
                    marginBottom: "16px",
                  }}
                >
                  {(editDoctorData.template_config.sectionOrder || []).map(
                    (sectionId, index) => (
                      <div
                        key={`${sectionId}-${index}`}
                        draggable
                        onDragStart={() => handleSectionDragStart(index)}
                        onDragOver={handleSectionDragOver}
                        onDrop={() => handleSectionDrop(index)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px 12px",
                          borderBottom:
                            index <
                              (editDoctorData.template_config.sectionOrder || [])
                                .length -
                              1
                              ? "1px solid #e8f4fc"
                              : "none",
                          backgroundColor: "#fff",
                          cursor: "grab",
                        }}
                      >
                        <DragIndicatorIcon
                          fontSize="small"
                          sx={{ color: "#125386", flexShrink: 0 }}
                        />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>
                            {TEMPLATE_SECTION_LABELS[sectionId] || sectionId}
                          </div>
                          <div
                            style={{
                              fontSize: "0.75rem",
                              color: "#888",
                              fontFamily: "monospace",
                            }}
                          >
                            {sectionId}
                          </div>
                        </div>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            margin: 0,
                            fontSize: "0.85rem",
                            flexShrink: 0,
                          }}
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          <input
                            type="checkbox"
                            checked={Boolean(
                              editDoctorData.template_config.sectionsVisibility?.[
                                sectionId
                              ] ?? true
                            )}
                            onChange={(e) =>
                              handleSectionVisibilityChange(
                                sectionId,
                                e.target.checked
                              )
                            }
                            onMouseDown={(e) => e.stopPropagation()}
                          />
                          Visible
                        </label>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="edit-template-base64">Template File (Base64)</label>
                <div className="form-group">
                  <input
                    id="edit-template-base64"
                    type="file"
                    className="form-control"
                    onChange={(e) => handleTemplateFileChange(e.target.files?.[0])}
                  />
                  {templateFileName ? (
                    <small>{templateFileName}</small>
                  ) : editDoctorData.template ? (
                    <small>Existing base64 template loaded</small>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className="col-sm-6 col-md-6 col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="edit-active"
                      checked={Boolean(editDoctorData.active)}
                      onChange={(e) =>
                        handleEditFieldChange("active", e.target.checked)
                      }
                    />
                    <label className="form-check-label" htmlFor="edit-active">
                      Active
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="col-sm-6 col-md-6 col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="edit-requires-signature"
                      checked={Boolean(editDoctorData.requires_prescription_signature)}
                      onChange={(e) =>
                        handleEditFieldChange(
                          "requires_prescription_signature",
                          e.target.checked
                        )
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="edit-requires-signature"
                    >
                      Requires Prescription Signature
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
              flexWrap: "nowrap",
              width: "100%",
            }}
          >
            <button
              type="button"
              onClick={closeEditModal}
              className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
              style={{ width: "50%", padding: "6px 10px", minWidth: "120px" }}
            >
              CANCEL
            </button>
            <button
              type="button"
              onClick={handleEditSave}
              className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
              style={{ width: "50%", padding: "6px 10px", minWidth: "120px" }}
            >
              SAVE CHANGES
            </button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={isDeleteModalOpen}
        onClose={handleCancelDelete}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-delete-modal"
        aria-describedby="confirm-delete-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-delete-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Deletion
          </h3>
          <p id="confirm-delete-description" style={{ fontSize: "20px" }}>
            Are you sure you want to delete this doctor?
          </p>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelDelete}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM DELETION
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={isReactivateModalOpen}
        onClose={handleCancelReactivate}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-reactivate-modal"
        aria-describedby="confirm-reactivate-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-reactivate-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Reactivation
          </h3>
          <p id="confirm-reactivate-description" style={{ fontSize: "20px" }}>
            Are you sure you want to reactivate this doctor?
          </p>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelReactivate}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmReactivate}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM REACTIVATION
            </Button>
          </Box>
        </Box>
      </Modal>


      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
          width: "100%",
          maxWidth: "1200px", // Set a max width for large screens
          // padding: "1rem",
        }}
      >
        <h4 style={{ textAlign: "center" }}>Doctor List</h4>
        {doctorlist.length > 0 ? (
          <div style={{ width: "100%", overflowX: "auto" }}>
            <DataGrid
              rows={doctorlist}
              columns={columns}
              processRowUpdate={async (newRow, oldRow) => {
                try {
                  return await handleDoctorEdit(newRow, oldRow);
                } catch (error) {
                  console.error("Error updating doctor:", error);
                  toast.error(
                    error?.response?.data?.message || "Unable to update doctor"
                  );
                  return oldRow;
                }
              }}
              onProcessRowUpdateError={(error) => {
                console.error("Row update failed:", error);
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[5, 10]}
              components={{
                Toolbar: () => (
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      mb: 2,
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={8}
                      sx={{ display: "flex", gap: 1 }}
                    >
                      <GridToolbarColumnsButton />
                      <GridToolbarFilterButton />
                      <GridToolbarDensitySelector />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: { xs: "center", sm: "flex-end" },
                      }}
                    >
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => generatePdf()}
                        startIcon={<SaveAlt />}
                      >
                        Download PDF
                      </Button>
                      <CSVLink
                        data={generateCsvData()}
                        filename={"Doctors_List.csv"}
                        target="_blank"
                      >
                        <Button
                          variant="text"
                          color="primary"
                          startIcon={<SaveAlt />}
                        >
                          Download CSV
                        </Button>
                      </CSVLink>
                    </Grid>
                  </Grid>
                ),
              }}
              getRowClassName={getRowClassName}
              sx={{
                "& .MuiDataGrid-root": {
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                  padding: "5px"
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#125386",
                  color: "white",
                  fontSize: "13px",
                  fontWeight: "600",
                  minHeight: "48px !important",
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white",
                    fontWeight: "600",
                    fontSize: "13px",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    padding: "0 12px",
                  },
                  "& .MuiDataGrid-columnHeader:last-child": {
                    borderRight: "none",
                  },
                  "& .MuiDataGrid-iconButtonContainer": {
                    color: "white",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-columnHeaderSortable": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-row": {
                  backgroundColor: "white",
                  minHeight: "40px !important",
                  "&:nth-of-type(even)": {
                    backgroundColor: "white",
                  },
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  },
                  borderBottom: "1px solid #e0e0e0",
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "12px",
                  color: "#374151",
                  padding: "8px 12px",
                  minHeight: "40px !important",
                  "&:last-child": {
                    borderRight: "none",
                  },
                  "&:focus": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: "12px",
                  color: "#374151",
                  fontWeight: "400",
                },
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #e0e0e0",
                  minHeight: "52px",
                },
                "& .MuiTablePagination-root": {
                  color: "#374151",
                  fontSize: "12px",
                },
                "& .MuiDataGrid-toolbarContainer": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "8px 16px",
                },
              }}
            />
          </div>
        ) : (
          <h3>No Doctors are added!!</h3>
        )}
      </div>
    </>
  );
}

export default DoctorList;
